import { root } from './regenerateSecret';

export const regenerateSecret = {
  ...root,
};
